// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4205":"5bdb0082","8688":"27dd0431"}[chunkId] + ".chunk.css";
};